import { useState } from "react";
import { Calendar } from "primereact/calendar";
import { CREATE_LEAD_URL } from "../../global/API";

const AddLead = (props) => {
  const { selectedListings } = props;
  const [newDates, setNewDates] = useState(null);
  const [userDetails, setUserDetials] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
    tourdate: new Date(),
    tourStatus: "No",
  });

  const onHandleEvent = (event) => {
    const { name, value } = event.target;
    setUserDetials((previousState) => ({ ...previousState, [name]: value }));
  };

  const onHandleSubmit = async (e) => {
    e.preventDefault();
    const { listingID, userAgentID } = selectedListings[0];
    const { name, email, phone, message, tourdate, tourStatus } = userDetails;
    const formValues = {
      agent_id: userAgentID,
      listing_id: listingID,
      type: tourStatus === "Yes" ? 3 : 1,
      tour_date: tourStatus === "Yes" ? tourdate : null,
      name,
      email,
      phone,
      message,
    };

    const formData = new FormData();
    Object.entries(formValues).forEach(([key, value]) => {
      console.log(key, value);
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    try {
      const options = {
        method: "POST",
        body: formData,
      };
      const response = await fetch(CREATE_LEAD_URL + "0", options);
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="modal fade filter-model leadPopup" id="addLead" aria-labelledby="addLeadLabel" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="addLeadLabel">
              Add New Lead
            </h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <i className="ri-close-line"></i>
            </button>
          </div>
          <div className="modal-body">
            <form onSubmit={onHandleSubmit}>
              <div className="mb-3">
                <label className="form-label">Name</label>
                <input type="name" name="name" onChange={onHandleEvent} className="form-control" value={userDetails.name} />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input type="email" name="email" onChange={onHandleEvent} className="form-control" value={userDetails.email} />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone</label>
                <input type="text" name="phone" onChange={onHandleEvent} className="form-control" value={userDetails.phone} />
              </div>
              <div className="mb-3">
                <label className="form-label d-block">Would you like to make a tour request?</label>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="tourStatus" id="inlineRadio1" value="Yes" checked={userDetails.tourStatus === "Yes"} onChange={onHandleEvent} />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Yes
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input className="form-check-input" type="radio" name="tourStatus" id="inlineRadio2" value="No" checked={userDetails.tourStatus === "No"} onChange={onHandleEvent} />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    No
                  </label>
                </div>
              </div>

              {userDetails.tourStatus === "Yes" && (
                <div className="mb-3">
                  <label className="form-label">Tour Date</label>
                  <div>
                    <Calendar
                      id="newLeadCalendar"
                      name="tourdate"
                      value={userDetails.tourdate}
                      onChange={(e) =>
                        setUserDetials((previousState) => ({
                          ...previousState,
                          tourdate: e.value,
                        }))
                      }
                      dateFormat="dd/mm/yy"
                      showTime
                      hourFormat="12"
                    />
                  </div>
                </div>
              )}
              {/* <div className="mb-3">
                <label className="form-label">Tour Time</label>
                &nbsp;&nbsp;
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="option1"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    8AM - 12PM
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="option2"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    12PM - 5PM
                  </label>
                </div>
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio3"
                    value="option3"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio3">
                    5PM - 9PM
                  </label>
                </div>
              </div> */}
              <div className="mb-3">
                <label className="form-label">Message</label>
                <textarea name="message" className="form-control" rows="3" value={userDetails.message} onChange={onHandleEvent}></textarea>
              </div>
              <div className="page-title-box">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
                {/* <button type="submit" className="btn btn-secondary">
                  Cancel
                </button> */}
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddLead;
